import { styled, Toolbar } from "@mui/material";

interface Props {
  setFooterRef: (ref: HTMLDivElement | null) => void;
}

export function Footer(props: Props) {
  const { setFooterRef } = props;
  return (
    <StyledFooter>
      <Toolbar ref={(ref) => setFooterRef(ref)}></Toolbar>
    </StyledFooter>
  );
}

const StyledFooter = styled("footer")`
  position: relative;
  bottom: 0;
  left: 0;
  width: 100%;
  max-height: 48px;
  .MuiToolbar-root {
    //TODO: fixme
    max-height: 48px;
    min-height: 48px;
  }
`;
